import { getPath } from '@/router/common'

const baseUrl = {
  title: '表格设置',
  path: 'CustomDisplay'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'CustomDisplay',
    component: () => import(/* webpackChunkName: "department" */ '@/views/customDisplay/index.vue'),
    meta: {
      title: '网格自定义'
    }
  },
  {
    path: getPath('ExportTemplate', baseUrl),
    name: 'ExportTemplate',
    component: () => import(/* webpackChunkName: "ExportTemplate" */ '@/views/customDisplay/exportTemplate/index.vue'),
    meta: {
      title: '导出模板自定义'
    }
  },
  {
    path: getPath('CustomConditions', baseUrl),
    name: 'CustomConditions',
    component: () => import(/* webpackChunkName: "CustomConditions" */ '@/views/customDisplay/customConditions/index.vue'),
    meta: {
      title: '表格行自定义颜色'
    }
  },
  {
    path: getPath('BillingJump', baseUrl),
    name: 'BillingJump',
    component: () => import(/* webpackChunkName: "BillingJump" */ '@/views/customDisplay/billingJump/index.vue'),
    meta: {
      title: '打开表格编辑设置'
    }
  }
]
